import { SpaceNamePipe } from './spaces/space-name.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
  ],
  declarations: [
    SpaceNamePipe
  ],
  exports: [
    SpaceNamePipe
  ],
  providers: [
    SpaceNamePipe
  ]
})
export class Fabric8WitModule {
}
